import { Container as PixiContainer, _ReactPixi } from '@inlet/react-pixi';
import { Container } from 'pixi.js';
import React, { FC, ReactNode } from 'react';

interface Props extends _ReactPixi.IContainer {
  children: ReactNode;
  forwardRef?: React.Ref<Container>;
}

export const CustomPixiContainer: FC<Props> = (props) => {
  return <PixiContainer {...props} ref={props.forwardRef} />;
};
